import api from "@/assets/js/api"; // 引用 API.js

export async function searchAvailableRooms(requestPayload) {
  try {
    const response = await api.post("/RoomType/search", requestPayload);

    return response.data.map((item) => ({
      id: item.RoomTypeId,
      name: item.RoomTypeName,
      serviceType: item.ServiceType,
      capacity: item.Capacity,
      pricePerNight: item.PricePerNight,
      availableRoomCount: item.AvailableRoomCount,
      roomNumbers: item.RoomNumbers,
      // 新增這些屬性
      description: item.Description, // 預設描述
      image: item.Image, // 直接使用後端回傳的完整檔案名稱
      stock: item.AvailableRoomCount, // 映射到 stock 屬性
      packages: item.Packages.map((p) => ({
        id: p.PackageId,
        name: p.PackageName,
        finalPrice: p.FinalPrice,
        basePrice: p.FinalPrice - item.PricePerNight, // 計算套餐額外費用
      })),
    }));
  } catch (error) {
    console.error("❌ 查詢可用房型失敗：", error);
    throw error;
  }
}
